export default __webpack_public_path__ + "static/media/trash.092979f2.svg";